export function inr(v, { compact = true } = {}) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const n = Number(v);
  const abs = Math.abs(n);
  if (compact && abs >= 1e7) return `₹${(n / 1e7).toFixed(abs >= 1e9 ? 1 : 2)} Cr`;
  if (compact && abs >= 1e5) return `₹${(n / 1e5).toFixed(1)} L`;
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function num(v, d = 0) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return Number(v).toLocaleString("en-IN", { maximumFractionDigits: d, minimumFractionDigits: d });
}

export function pct(v, d = 1) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return `${Number(v).toFixed(d)}%`;
}

export function weeks(v) {
  if (v === null || v === undefined) return "∞";
  return `${Number(v).toFixed(1)} wk`;
}

export function fmtDate(s) {
  if (!s) return "—";
  const d = new Date(s);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(s) {
  if (!s) return "—";
  return new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export const HEALTH_STYLE = {
  "Healthy": "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  "Fast Seller": "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800",
  "Replenishment Risk": "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  "Stock-out": "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800",
  "Overstock": "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/40 dark:text-orange-300 dark:border-orange-800",
  "Ageing": "bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-950/40 dark:text-violet-300 dark:border-violet-800",
  "Dead Stock": "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
  "Sold Out": "bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-950/40 dark:text-teal-300 dark:border-teal-800",
};

export const HEALTH_COLOR = {
  "Healthy": "#10b981", "Fast Seller": "#0ea5e9", "Replenishment Risk": "#f59e0b", "Stock-out": "#f43f5e",
  "Overstock": "#f97316", "Ageing": "#8b5cf6", "Dead Stock": "#64748b", "Sold Out": "#14b8a6",
};

export const STATUS_STYLE = {
  pending: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300",
  modified: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300",
  rejected: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300",
  open: "bg-sky-50 text-sky-700 border-sky-200", resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  ignored: "bg-slate-100 text-slate-600 border-slate-200", matched: "bg-emerald-50 text-emerald-700 border-emerald-200",
  mismatch: "bg-amber-50 text-amber-700 border-amber-200", negative: "bg-rose-50 text-rose-700 border-rose-200",
  critical: "bg-rose-600 text-white border-rose-700", high: "bg-amber-500 text-white border-amber-600",
  medium: "bg-sky-500 text-white border-sky-600", low: "bg-slate-400 text-white border-slate-500",
};

export const QUEUE_LABEL = { stockout: "Stock-out", overstock: "Overstock", transfer: "Transfer", ageing: "Ageing", allocation: "Allocation" };
